<div [innerHTMLBypassXSS]="content" [trimRichtextTitle]="content | translate" translate></div>
<kendo-dialog-actions>
    <button *ngIf="showCancel" kendoButton class="cancel-button"
        (click)="onCancelClick()" translate>
        <i></i>&nbsp;
        {{cancelText}}
    </button>
    <button kendoButton class="confirm-button" (click)="onConformClick()" translate>
        <i></i>&nbsp;
        {{confirmText}}
    </button>
</kendo-dialog-actions>